export default __webpack_public_path__ + "static/media/8108a05fe545e323b905037536d52ffe1576249003483.7d4e4502.webp";